import { AlertMessage } from "layout/alert/Alert";

export default async function OCRReader(url = "", documentType = "password"){

    // holds expected type of message
    const expectedTypes = ["CardContentText", "Images"];

    // holds received message
    const receivedData = {};

    try {                    
        return new Promise((resolve, reject) => {
            let documentType = null;

            // creating socket instance
            const socket = new WebSocket(url);  
        
            // when socket connection is estabished
            socket.onopen = async () => {   
                console.log("WebSocket connected");   
                
                // setting timeout to close socket
                setTimeout(() => {
                    if(socket){
                        socket.close();
                    }
                }, 15000)

                //#region Device Status

                var status_request = {
                    Type: "Request",
                    Commands: [
                        {Command:"Get", Operand:"OnLineStatus"},
                        {Command:"Get", Operand:"DeviceName"},
                        {Command:"Get", Operand:"DeviceType"},
                        {Command:"Get", Operand:"DeviceSerialNo"},
                        {Command:"Get", Operand:"VersionInfo"}
                    ]
                };

                socket.send(JSON.stringify(status_request));
                
                //#endregion       
                
                
                //#region Connection Setup
                
                if(documentType != "passport"){
                    let setup_request_data = {
                        "Type": "Request",
                        "Commands": [
                            {Command: "Set", Operand: "RFID", Param: "N"},
                            {Command: "Set", Operand: "VIZ", Param: "N"},
                        ]
                    }
        
                    socket.send(JSON.stringify(setup_request_data));

                    let image_setup_request_data = {
                        "Type": "Notify",
                        "Commands": [
                            {Command: "Set", Operand: "Images", Param: "White"},
                            {Command: "Set", Operand: "Images", Param: "IR"},
                        ]
                    }
                                                
                    socket.send(JSON.stringify(image_setup_request_data));
                }

                //#endregion 
            };            
        
            // receiving message from socket
            socket.onmessage = (event) => {                                
                try {
 
                    // extracting received data
                    const data = JSON.parse(event.data);                
console.log("Scanner Data => ", data);
                    if(data?.Type == "Reply" && (data?.Commands || []).length > 0){
                        (data?.Commands || []).forEach(async (replay) => {
                            
                            if(replay?.Operand == "OnLineStatus"){
                                // Handles devices online status
                                if(replay?.Succeeded != "Y"){
                                    socket.close(1000, "Device Not Connected.");
                                }
                            }                            
                        })
                    }

                    
                    //#region Data Scanning

                    if (data.Command == 'Save' && expectedTypes.includes(data.Operand))
                    {
                        if(data.Operand == "CardContentText"){
                            receivedData['card'] = data.Param;
                        }else if(data.Operand == "Images"){
                            receivedData['image'] = data.Param                            
                        }
                    }    
    
                    const received_type = Object.keys(receivedData); 
                    // type of data expected
                    let typeCollection = documentType != "passport" ? ["image"] : ['card', 'image'];   
console.log("typeCollection => ", typeCollection)
                    // Check if all expected types have been received
                    if (typeCollection.every(type => received_type.includes(type))) {                    
                        socket.close();
                        resolve({
                            ...receivedData,
                            documentType: documentType
                        });
                    }

                    //#endregion
                    
                } catch (err) {
                    console.error("Error parsing message:", err);
                    reject(err);
                }
            };
            
            // when scan is completed
            socket.onclose = (data) => {     
                let reason = (data?.reason || "Scanner Closed.")
                console.log("Socket Closed: ", reason);
                reject(reason);
            };
        
            // in case of exception
            socket.onerror = (err) => {
                reject(err)
                console.error("WebSocket error:", err);
            };
        })
    } catch(err){
        console.log("Error: ", err)
    }
}

export function OCRPopUP(passportCallback = null, documentCallback = null, cancelCallBack = null){
    return new Promise((resolve, reject) => {
        AlertMessage({
            type: 'warning',
            title: "Scan", 
            message: "Ensure the document is placed only after the loading screen is visible.", 
            btnTypeId: 3,
            btnConfirmText: "Scan Passport",
            confirmCallBack: function() {
                passportCallback && passportCallback();
                resolve("passport");
            }, 
            btnCancelText: "Cancel",
            cancelCallBack: function() {
                cancelCallBack && cancelCallBack();
                reject("Scan Cancelled.");
            },
            btnExtraActionText: "Scan Other Documents",
            extraActionCallBack: function() {                
                documentCallback && documentCallback();
                resolve("other")
            }
        })
    })
}


export function PassportExpiryPopUp(){
    return new Promise ((resolve, reject) => {
        AlertMessage({
            type: 'warning',
            title: "Expired", 
            message: "The passport has been expired.", 
            btnTypeId: 1,
            btnConfirmText: "Close",
            confirmCallBack: () => {
                resolve();
            }
        })
    })
}